import React, { useState, useEffect } from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import { FaExternalLinkAlt, FaDatabase } from "react-icons/fa";
import { useSocketState } from "../../helpers/useSocket";
import BracketSet from '../../components/Bracket/BracketSet';
import groupBy from 'lodash/groupBy'

function BracketDashboard() {

	const { socket } = useOutletContext()

	const [tournament] = useSocketState('Tournament');

	function handleTournamentSlugChange(el) {
		setTournamentSlug(el.target.value);
	}
	const [tournamentSlug, setTournamentSlug] = useState(null);

	useEffect(() => {
		if (tournament?.bracket?.slug && !tournamentSlug) {
			const cleaned = String(tournament.bracket.slug).replace("tournament/", "");
			setTournamentSlug(cleaned);
		}
	}, [tournament, tournamentSlug]);

	// track expanded/collapsed state for each phase by id
	const [expandedPhases, setExpandedPhases] = useState({});

	function togglePhase(id, defaultExpanded) {
		setExpandedPhases(prev => ({ ...prev, [id]: typeof defaultExpanded === 'undefined' ? !prev[id] : defaultExpanded }));
	}


	//Ideally this should be able to handle multiple different format
	//And be able to return the same slug
	//https://www.start.gg/tournament/egc-masters-finals-2025/event/main-event/brackets/2124223/3097036
	//https://www.start.gg/tournament/egc-masters-finals-2025/
	//tournament/egc-masters-finals-2025/
	//egc-masters-finals-2025
	function handleGetTournament() {
		const slug = tournamentSlug //TODO insert regex here
		socket.emit('setTournamentSlug', slug);
	}

	return <div>
		<div className='flex flex-col mb-4'>
			<label>Tournament Slug/ID</label>
			<div className='flex flex-col'>
				<div className='flex flex-row'>
					{/*TODO Should possibly use the tournament.tournamentKey instead */}
					<input type="text" id="mapDraftUrl" name="mapDraftUrl" className='w-56 mr-8' value={tournamentSlug ?? ''} onChange={handleTournamentSlugChange} />
					<button className='h-8 my-auto mr-2' onClick={handleGetTournament}>Get Tournament</button>
				</div>
				<h1>Using {tournament?.bracketProvider}</h1>
			</div>
		</div>

		{tournament?.bracket &&
			tournament?.bracket?.events?.map(event =>
				<div>
					<h1 className='font-bold text-xl'>{event.name}</h1>
					{event.phases.map(phase =>
						<div className='ml-4' key={phase.id}>
							<div className='flex items-center'>
								<button
									type="button"
									onClick={() => togglePhase(phase.id)}
									className='mr-2 w-6 h-6 flex items-center justify-center rounded hover:bg-gray-200'
									aria-expanded={!!(expandedPhases[phase.id] ?? (phase.state === 'ACTIVE'))}
									aria-controls={`phase-${phase.id}`}
								>
									{(expandedPhases[phase.id] ?? (phase.state === 'ACTIVE')) ? '▾' : '▸'}
								</button>

								<h1 className='text-lg'>{phase.name} - {phase.bracketType} - {phase.state} - {phase.id}</h1>
								<Link className='mx-1' to={`/BracketDisplay?id=${phase.id}`} target='_blank'><button className='bg-teal-700 hover:bg-teal-800 rounded flex flex-row'>Bracket View<FaExternalLinkAlt /></button></Link>
								<Link className='mx-1' to={`/api/vmix/startggBracket/${phase.id}`} target='_blank'><button className='bg-teal-700 hover:bg-teal-800 rounded flex flex-row'><FaDatabase /></button></Link>
							</div>

							<div id={`phase-${phase.id}`} className={(expandedPhases[phase.id] ?? (phase.state === 'ACTIVE')) ? 'mt-2' : 'mt-2 hidden'}>
								<div className='flex flex-row'>
									{phase.phaseGroups?.nodes.map((phaseGroup, phaseIndex) =>
										<div className='flex flex-col'>
											<a className="" href={phaseGroup.bracketUrl} target='_blank' rel="noreferrer">Pool #{phaseIndex + 1} - {phaseGroup.id}</a>
											<div key={phaseGroup.id} className={`ml-8 ${phase.bracketType} ${phase.bracketType}_${phase.numSeeds} flex`}>
												{
													Object.keys(groupBy(phaseGroup.sets.nodes, 'round'))
														.sort((a, b) => Number(a) - Number(b))
														.map(round => (
															<div key={round} className={`round-group round_${round}`}>
																<h3>Round {round}</h3>
																{groupBy(phaseGroup.sets.nodes, 'round')[round].map(set => (
																	<div key={set.id}>
																		<BracketSet id={set.id} identifier={set.identifier} round={set.round} totalGames={set.totalGames} slots={set.slots} />
																	</div>
																))}
															</div>
														))
												}
											</div>
										</div>

									)}
								</div>
							</div>
						</div>
					)}
					<hr></hr>
				</div>
			)
		}
	</div>
}

export default BracketDashboard;